import { Box, Tab, Tabs } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Route,
  Link as RouterLink,
  Routes,
  useLocation,
} from "react-router-dom";
import AnalysisCountsGrid from "../../components/Compliance/AnalysisCountsGrid";
import { DatasetType } from "../../types/Compliance";
import LoremJokesumPlaceholder from "../../components/UI/LoremIpsumPlaceholder";


const AnalysisReportsMain: React.FC<{}> = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [selectedTabName, setSelectedTabName] = useState<string>("");


  const tabs = [
    { name: "Deliveries", path: "/data-ops/analysis-reports" },
    { name: "Samples", path: "/data-ops/analysis-reports/samples" },
    { name: "Volume Upgrades", path: "/data-ops/analysis-reports/volume-upgrades" },
    { name: "Countries", path: "/data-ops/analysis-reports/countries" },
    { name: "States", path: "/data-ops/analysis-reports/states" },
  ];

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((tab) =>
      location.pathname.endsWith(tab.path.split("/").pop() || "")
    );
    setSelectedTab(currentTabIndex === -1 ? 0 : currentTabIndex);
    setSelectedTabName(
      currentTabIndex === -1 ? tabs[0].name : tabs[currentTabIndex].name
    );
  }, [location.pathname]);

  useEffect(() => {
    document.title = `Analysis Reports - ${selectedTabName}`;
  }, [selectedTabName]);

  return (
    <Box>
      <h1>Analysis Reports</h1>

      {/* Tabs navigation */}
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        sx={{ marginBottom: 2 }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            component={RouterLink}
            to={tab.path}
          />
        ))}
      </Tabs>

      {/* Routes to render content */}
      <Routes>
        <Route
          path="/"
          element={<AnalysisCountsGrid datasetType="delivery"/>}
        />

        <Route
          path="Samples"
          element={<AnalysisCountsGrid datasetType="sample" />}
        />
        <Route
          path="volume-upgrades"
          element={
            <AnalysisCountsGrid datasetType="volume_upgrade"/>
          }
        />
        <Route
          path="Countries"
          element={
            <AnalysisCountsGrid datasetType="country"/>
          }
        />
        <Route
          path="States"
          element={
            <AnalysisCountsGrid datasetType="state"/>
          }
        />
      </Routes>
    </Box>
  );
};

export default AnalysisReportsMain;